import Vue from 'vue';
import { Form, FormItem, Button, Input } from 'element-ui';
// import { i18n } from '@/i18n';

Vue.use(Form);
Vue.use(FormItem);
Vue.use(Button);
Vue.use(Input);
